enum UserType {
  USER = 'USER',
  SYSTEM = 'SYSTEM',
}

export default UserType;
